module.exports = __webpack_public_path__ + "static/media/colourOptions01-min.6947d3fd.JPG";